import IRoleItem from './role-item';

export interface IFilters {
    centerId: number,
    contactEntityTypeId: number,
    search: string,
    centerRole: number,
    adminRoles: IRoleItem[]
}
